package org.example.site_web.content

import com.varabyte.kobweb.compose.foundation.layout.Box
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span

data class YourNeedEntry(var title: String = "", var description: String = "")


val yourNeedsContentMap = mapOf(
    "IMPROVE" to YourNeedEntry("Améliorer l’opérationnel" ,
     "Au sein de votre production, de votre maintenance ou de vos processus qualité vous identifiez des goulots d’étranglements et des problèmes récurrents.\r\n\r\n" +
        "Les solutions clés en main sont hors de portée financière et vos ressources internes ne sont pas dimensionnées pour mettre en place des solutions.\r\n\r\n"+
        "Ces pertes évitables et la frustration minent durablement vos résultats, votre confiance et la cohésion de vos équipes."),
    "EXPLORE" to YourNeedEntry("Explorer un sujet innovant",
            "Vous êtes sur un marché en quête de nouveautés et de fonctionnalités techniques toujours plus exigeant.\r\n\r\n"+
            "L’évolution de vos produits est reportée par un maillon manquant dans vos compétences internes, l'arbitrage est difficile "+
            "face aux exigences normatives et réglementaires chronophages.\r\n\r\n"+
            "La complexité des nouvelles technologies, le besoin de ressources humaines et de moyens coûteux affectent vos perspectives "+
            "d’expansion et votre confiance en l’avenir."),
    "OPTIMIZE" to YourNeedEntry("Optimiser les outils",
            "Vos équipes sont impliquées et votre infrastructure moderne.\r\n\r\n"+
            "Vous pensez qu’aujourd’hui est le moment favorable pour combiner la formation de vos collaborateurs sur de nouveaux "+
            "sujets techniques ainsi que l’exploitation à 100% des fonctionnalités de vos outils.\r\n\r\n"+
            "Il est temps de suivre votre intuition et de chercher le coup de pouce dont vous avez besoin pour franchir un nouveau cap.")
)